/* Annonces entre particuliers : liste, page d'annonce, mes annonces, messagerie, favoris et alertes. */
(() => {
  'use strict';
  const root = document.querySelector('[data-sra]');
  if (!root || root.dataset.sraReady) return;
  root.dataset.sraReady = '1';

  const C = JSON.parse((root.querySelector('[data-sra-i18n]') || {}).textContent || '{"t":{}}');
  // Le filtre t de Shopify échappe le HTML : on décode une fois pour textContent.
  const dec = document.createElement('textarea');
  for (const k in C.t) { dec.innerHTML = C.t[k]; C.t[k] = dec.value; }
  const t = (k, vars) => {
    let s = (C.t && C.t[k]) || '';
    if (vars) for (const [a, b] of Object.entries(vars)) s = s.split(`__${a}__`).join(b);
    return s;
  };
  const errMsg = code => (C.t && C.t[`err_${code}`]) || t('err_generic');
  const loc = String(C.locale || 'fr').slice(0, 2) + '-BE';
  // Même format de prix que la boutique (modèle rendu par Liquid pour 1000).
  const money = n => {
    const m = /^(\D*)1(\D?)000(\D*)$/.exec(String(C.money || '').trim());
    if (!m) return new Intl.NumberFormat(loc, { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(n);
    return m[1] + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, m[2]) + m[3];
  };
  const num = n => new Intl.NumberFormat(loc).format(n);
  const norm = s => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch { /* stockage indisponible */ } },
    del(k) { try { localStorage.removeItem(k); } catch { /* stockage indisponible */ } }
  };

  async function api(route, opts = {}) {
    const url = `${C.proxy}/${route}${route.includes('?') ? '&' : '?'}locale=${encodeURIComponent(C.locale || 'fr')}`;
    const init = { method: opts.method || (opts.json ? 'POST' : 'GET'), credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (opts.json) { init.headers['Content-Type'] = 'application/json'; init.body = JSON.stringify(opts.json); }
    let data;
    try {
      const res = await fetch(url, init);
      data = await res.json();
    } catch { data = { ok: false, error: 'generic' }; }
    if (!data || !data.ok) { const e = new Error((data && data.error) || 'generic'); e.code = (data && data.error) || 'generic'; throw e; }
    return data;
  }
  const loginUrl = ret => `${C.login}&return_to=${encodeURIComponent(ret || location.pathname + location.search)}`;

  function toast(msg, ms = 2400) {
    document.querySelectorAll('.sra-toast').forEach(x => x.remove());
    const el = document.createElement('div');
    el.className = 'sra-toast'; el.setAttribute('role', 'status'); el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(() => el.remove(), ms);
  }

  function relativeDates(scope) {
    const now = new Date(); now.setHours(0, 0, 0, 0);
    scope.querySelectorAll('[data-relative]').forEach(el => {
      const ts = Number(el.dataset.relative) * 1000;
      if (!ts) return;
      const d = new Date(ts); d.setHours(0, 0, 0, 0);
      const days = Math.round((now - d) / 86400000);
      if (days <= 0) el.textContent = t('today');
      else if (days === 1) el.textContent = t('yesterday');
      else if (days < 30) el.textContent = t('days_ago', { N: days });
    });
    scope.querySelectorAll('[data-date-long]').forEach(el => {
      const d = new Date(el.getAttribute('datetime'));
      if (!isNaN(d)) el.textContent = d.toLocaleDateString(loc, { day: 'numeric', month: 'long', year: 'numeric' });
    });
    scope.querySelectorAll('.sra-card__meta, [data-num]').forEach(el => {
      el.textContent = el.textContent.replace(/\b(\d{4,6})(?= ?km)/g, m => num(Number(m)));
    });
  }

  function confirmBox(message, okLabel) {
    return new Promise(resolve => {
      const d = document.createElement('dialog');
      d.className = 'sra-dialog';
      d.innerHTML = `<form method="dialog"><p>${esc(message)}</p><div class="sra-dialog__actions">
        <button class="sra-btn sra-btn--ghost sra-btn--small" value="no">${esc(t('cancel'))}</button>
        <button class="sra-btn sra-btn--primary sra-btn--small" value="yes">${esc(okLabel)}</button></div></form>`;
      document.body.appendChild(d);
      // On répond sans attendre l'événement « close », qui peut être retardé quand l'onglet n'est pas affiché.
      let done = false;
      const finish = v => { if (done) return; done = true; resolve(v); if (d.open) d.close(); d.remove(); };
      d.querySelector('form').addEventListener('submit', e => { e.preventDefault(); finish(!!e.submitter && e.submitter.value === 'yes'); });
      d.addEventListener('cancel', () => finish(false));
      d.addEventListener('close', () => finish(d.returnValue === 'yes'));
      d.showModal();
    });
  }

  // Fenêtre « Faire une offre » : renvoie { prix, message } ou null si annulée.
  function offerDialog({ title, demande, withMessage }) {
    return new Promise(resolve => {
      const d = document.createElement('dialog');
      d.className = 'sra-dialog';
      d.innerHTML = `<form method="dialog" class="sra-offer-form" novalidate>
        <h2>${esc(title)}</h2>
        ${demande ? `<p class="sra-hint" style="margin:0">${esc(t('offer_asking', { P: money(demande) }))}</p>` : ''}
        <div class="sra-field">
          <label class="sra-label" for="sra-offer-prix">${esc(t('offer_amount'))}</label>
          <input class="sra-input" id="sra-offer-prix" name="prix" inputmode="numeric" autocomplete="off" maxlength="6" required>
        </div>
        ${withMessage ? `<div class="sra-field">
          <label class="sra-label" for="sra-offer-msg">${esc(t('offer_message'))}</label>
          <textarea class="sra-textarea" id="sra-offer-msg" name="message" rows="3" maxlength="2000" style="min-height:5rem"></textarea>
        </div>` : ''}
        <p class="sra-error" data-error hidden></p>
        <div class="sra-dialog__actions">
          <button type="button" class="sra-btn sra-btn--ghost sra-btn--small" data-cancel>${esc(t('cancel'))}</button>
          <button type="submit" class="sra-btn sra-btn--primary sra-btn--small">${esc(t('offer_send'))}</button>
        </div></form>`;
      document.body.appendChild(d);
      const f = d.querySelector('form');
      const err = d.querySelector('[data-error]');
      let done = false;
      const finish = v => { if (done) return; done = true; resolve(v); if (d.open) d.close(); d.remove(); };
      d.querySelector('[data-cancel]').addEventListener('click', () => finish(null));
      d.addEventListener('cancel', () => finish(null));
      d.addEventListener('close', () => finish(null));
      f.addEventListener('submit', e => {
        e.preventDefault();
        const prix = Math.round(Number(String(f.elements.prix.value).replace(/[^\d]/g, '')));
        if (!prix || (demande && prix > demande)) { err.textContent = t('err_offer_invalid'); err.hidden = false; f.elements.prix.focus(); return; }
        finish({ prix, message: f.elements.message ? f.elements.message.value.trim() : '' });
      });
      d.showModal();
      f.elements.prix.focus();
    });
  }

  /* ---------------------------------------------------------------- */
  /* Favoris : sur l'appareil, et sur le compte quand on est connecté  */
  /* ---------------------------------------------------------------- */
  const FAV_KEY = 'sra_favs';
  const Fav = {
    set: new Set(),
    local() { try { const v = JSON.parse(store.get(FAV_KEY) || '[]'); return Array.isArray(v) ? v.filter(x => typeof x === 'string') : []; } catch { return []; } },
    saveLocal() { store.set(FAV_KEY, JSON.stringify([...this.set].slice(0, 200))); },
    async load() {
      const local = this.local();
      if (C.customer) {
        try {
          // Favoris gardés avant la connexion : on les rattache au compte.
          const d = local.length ? await api('favori', { json: { ids: local.slice(0, 50), on: true } }) : await api('favoris');
          if (local.length) store.del(FAV_KEY);
          this.set = new Set(d.ids || []);
        } catch { this.set = new Set(local); }
      } else this.set = new Set(local);
      this.paint();
    },
    has(id) { return this.set.has(id); },
    async toggle(id) {
      const on = !this.set.has(id);
      if (on) this.set.add(id); else this.set.delete(id);
      this.paint();
      toast(t(on ? 'fav_added' : 'fav_removed'));
      document.dispatchEvent(new CustomEvent('sra:favs'));
      if (!C.customer) { this.saveLocal(); return; }
      try {
        const d = await api('favori', { json: { id, on } });
        this.set = new Set(d.ids || []);
      } catch (ex) {
        if (on) this.set.delete(id); else this.set.add(id);
        toast(errMsg(ex.code));
        document.dispatchEvent(new CustomEvent('sra:favs'));
      }
      this.paint();
    },
    paint() {
      document.querySelectorAll('[data-fav]').forEach(b => {
        const on = this.set.has(b.dataset.fav);
        b.hidden = false;
        b.setAttribute('aria-pressed', String(on));
        const label = b.querySelector('[data-fav-label]');
        if (label) label.textContent = t(on ? 'fav_on' : 'fav_add');
        else b.setAttribute('aria-label', t(on ? 'fav_remove' : 'fav_add'));
      });
    }
  };
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-fav]');
    if (!b) return;
    e.preventDefault();
    Fav.toggle(b.dataset.fav);
  });

  /* ---------------------------------------------------------------- */
  /* Alertes : un e-mail dès qu'une nouvelle annonce correspond        */
  /* ---------------------------------------------------------------- */
  const ALERT_KEY = 'sra_alert_pending';
  async function createAlert(criteria) {
    if (!C.customer) {
      store.set(ALERT_KEY, JSON.stringify(criteria));
      location.href = loginUrl(location.pathname + location.search);
      return;
    }
    try {
      const d = await api('alerte', { json: { action: 'create', ...criteria } });
      toast(t(d.existing ? 'alert_exists' : 'alert_created'), 4500);
    } catch (ex) {
      if (ex.code === 'login_required') { store.set(ALERT_KEY, JSON.stringify(criteria)); location.href = loginUrl(); return; }
      toast(errMsg(ex.code), 4500);
    }
  }
  function resumeAlert() {
    if (!C.customer) return;
    const raw = store.get(ALERT_KEY);
    if (!raw) return;
    store.del(ALERT_KEY);
    try { createAlert(JSON.parse(raw)); } catch { /* critères illisibles */ }
  }

  /* ---------------------------------------------------------------- */
  /* Liste                                                             */
  /* ---------------------------------------------------------------- */
  function initListe() {
    relativeDates(root);
    const grid = root.querySelector('[data-grid]');
    const form = root.querySelector('[data-filters]');
    // Critères de la recherche en cours et libellé lisible (repris dans l'e-mail).
    const criteria = () => {
      if (!form) return { label: t('alert_all') };
      const el = form.elements;
      const v = k => (el[k] ? el[k].value.trim() : '');
      const opt = k => (el[k] && el[k].value ? el[k].options[el[k].selectedIndex].text.trim() : '');
      const parts = [v('q'), opt('marque'), opt('prix'), opt('etat'), v('lieu')].filter(Boolean);
      return { q: v('q'), marque: v('marque'), prix: v('prix'), etat: v('etat'), lieu: v('lieu'), label: parts.join(' · ') || t('alert_all') };
    };
    root.querySelectorAll('[data-alert]').forEach(b => b.addEventListener('click', async () => {
      b.disabled = true;
      await createAlert(criteria());
      b.disabled = false;
    }));
    resumeAlert();
    if (!grid || !form) return;
    const pageSize = Number(root.dataset.pageSize) || 24;
    const cards = [...grid.querySelectorAll('[data-annonce]')].map((el, i) => ({
      el, i,
      marque: el.dataset.marque, prix: Number(el.dataset.prix) || 0, etat: el.dataset.etat,
      cp: norm(el.dataset.cp), date: Number(el.dataset.date) || 0, q: norm(el.dataset.q + ' ' + el.dataset.marque),
      vendue: el.dataset.vendue === '1' ? 1 : 0
    }));
    const countEl = root.querySelector('[data-count]');
    const emptyEl = root.querySelector('[data-empty]');
    const moreWrap = root.querySelector('[data-more-wrap]');
    const resets = root.querySelectorAll('[data-reset]');
    const fields = ['q', 'marque', 'prix', 'etat', 'lieu', 'tri'];
    let page = 1;

    const params = new URLSearchParams(location.search);
    fields.forEach(f => { if (params.has(f) && form.elements[f]) form.elements[f].value = params.get(f); });
    if ([...form.elements.marque.options].every(o => o.value !== form.elements.marque.value)) form.elements.marque.value = '';

    function state() {
      const s = {};
      fields.forEach(f => { s[f] = form.elements[f] ? form.elements[f].value.trim() : ''; });
      return s;
    }

    function apply(keepPage) {
      if (!keepPage) page = 1;
      const s = state();
      const words = norm(s.q).split(/\s+/).filter(Boolean);
      const lieu = norm(s.lieu);
      const max = Number(s.prix) || 0;
      let list = cards.filter(c => {
        if (s.marque && c.marque !== s.marque) return false;
        if (max && c.prix > max) return false;
        if (s.etat && c.etat !== s.etat) return false;
        if (lieu) {
          if (/^\d+$/.test(lieu)) { if (!c.cp.startsWith(lieu)) return false; }
          else if (!c.q.includes(lieu)) return false;
        }
        return words.every(w => c.q.includes(w));
      });
      if (s.tri === 'prix_asc') list.sort((a, b) => a.prix - b.prix || b.date - a.date);
      else if (s.tri === 'prix_desc') list.sort((a, b) => b.prix - a.prix || b.date - a.date);
      else list.sort((a, b) => b.date - a.date || a.i - b.i);
      // Annonces vendues (bandeau VENDUE, 7 jours) toujours en fin de liste.
      list.sort((a, b) => a.vendue - b.vendue);

      const shown = new Set(list.slice(0, page * pageSize).map(c => c.el));
      list.forEach(c => grid.appendChild(c.el));
      cards.forEach(c => { c.el.hidden = !shown.has(c.el); });

      countEl.textContent = list.length === 1 ? t('count_one') : t('count_many', { N: list.length });
      emptyEl.hidden = list.length > 0;
      grid.hidden = list.length === 0;
      moreWrap.hidden = list.length <= page * pageSize;
      const active = ['q', 'marque', 'prix', 'etat', 'lieu'].some(f => s[f]);
      resets.forEach(b => { b.hidden = !active && b.closest('[data-empty]') === null; });

      const p = new URLSearchParams();
      fields.forEach(f => { if (s[f] && !(f === 'tri' && s[f] === 'recent')) p.set(f, s[f]); });
      const qs = p.toString();
      history.replaceState(null, '', location.pathname + (qs ? `?${qs}` : ''));
    }

    let timer;
    form.addEventListener('input', e => {
      clearTimeout(timer);
      timer = setTimeout(() => apply(false), e.target.tagName === 'SELECT' ? 0 : 200);
    });
    form.addEventListener('change', () => apply(false));
    resets.forEach(b => b.addEventListener('click', () => {
      ['q', 'marque', 'prix', 'etat', 'lieu'].forEach(f => { form.elements[f].value = ''; });
      apply(false);
    }));
    root.querySelector('[data-more]').addEventListener('click', () => { page += 1; apply(true); });
    const toggle = root.querySelector('[data-toggle-filters]');
    toggle.addEventListener('click', () => {
      const open = form.dataset.collapsed === 'true';
      form.dataset.collapsed = open ? 'false' : 'true';
      toggle.setAttribute('aria-expanded', String(open));
    });
    if (['marque', 'prix', 'etat', 'lieu'].some(f => form.elements[f].value)) { form.dataset.collapsed = 'false'; toggle.setAttribute('aria-expanded', 'true'); }
    apply(false);
  }

  /* ---------------------------------------------------------------- */
  /* Page d'annonce                                                    */
  /* ---------------------------------------------------------------- */
  function initDetail() {
    relativeDates(root);
    const id = root.dataset.id;

    // Vue comptée une fois par visiteur et par 12 h (pas pour le vendeur ni les robots)
    if (!root.dataset.owner && !navigator.webdriver) {
      const vk = `sra_vu_${id}`;
      if (Date.now() - Number(store.get(vk) || 0) > 12 * 3600 * 1000) {
        store.set(vk, String(Date.now()));
        api('vue', { json: { id } }).catch(() => {});
      }
    }

    // Galerie
    const track = root.querySelector('[data-track]');
    if (track) {
      const slides = [...track.querySelectorAll('[data-slide]')];
      const counter = root.querySelector('[data-counter]');
      const thumbs = [...root.querySelectorAll('[data-thumb]')];
      let index = 0;
      const go = i => {
        index = (i + slides.length) % slides.length;
        track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
      };
      const sync = () => {
        const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i === index && counter && counter.dataset.init) return;
        index = Math.min(slides.length - 1, Math.max(0, i));
        if (counter) { counter.textContent = `${index + 1} / ${slides.length}`; counter.dataset.init = '1'; }
        thumbs.forEach((b, k) => b.setAttribute('aria-current', String(k === index)));
        const active = thumbs[index];
        if (active) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      };
      let raf;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
      root.querySelector('[data-prev]')?.addEventListener('click', () => go(index - 1));
      root.querySelector('[data-next]')?.addEventListener('click', () => go(index + 1));
      thumbs.forEach((b, k) => b.addEventListener('click', () => go(k)));
      track.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      });
      const lb = root.querySelector('[data-lightbox]');
      const lbImg = root.querySelector('[data-lightbox-img]');
      if (lb && lb.showModal) {
        slides.forEach(s => s.querySelector('img')?.addEventListener('click', e => {
          const img = e.currentTarget;
          const srcs = (img.getAttribute('srcset') || '').split(',').map(x => x.trim().split(' ')[0]).filter(Boolean);
          lbImg.src = srcs[srcs.length - 1] || img.currentSrc || img.src;
          lbImg.alt = img.alt;
          lb.showModal();
        }));
        root.querySelector('[data-close-lightbox]').addEventListener('click', () => lb.close());
        lb.addEventListener('click', e => { if (e.target === lb || e.target === lbImg) lb.close(); });
      }
    }

    // Partage
    root.querySelector('[data-share]')?.addEventListener('click', async () => {
      const data = { title: document.title, url: location.href.split('?')[0] };
      try {
        if (navigator.share) { await navigator.share(data); return; }
        await navigator.clipboard.writeText(data.url);
        toast(t('link_copied'));
      } catch { /* partage annulé */ }
    });

    // Contact
    const form = root.querySelector('[data-contact]');
    if (form) {
      const msg = form.elements.message;
      const err = form.querySelector('[data-error]');
      const key = `sra_msg_${id}`;
      const saved = store.get(key);
      if (saved && C.customer) {
        msg.value = saved;
        requestAnimationFrame(() => {
          document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          msg.focus({ preventScroll: true });
        });
      }
      const showErr = text => { err.textContent = text; err.hidden = !text; msg.closest('.sra-field').dataset.invalid = text ? 'true' : 'false'; };
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const message = msg.value.trim();
        if (message.length < 10) { showErr(t('err_message_too_short')); msg.focus(); return; }
        showErr('');
        if (!C.customer) {
          store.set(key, message);
          location.href = loginUrl(`${location.pathname}?contact=1`);
          return;
        }
        const btn = form.querySelector('[data-send]');
        btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = t('contact_sending');
        try {
          const res = await api('contact', { json: { id, message, nom: form.elements.nom ? form.elements.nom.value : '' } });
          store.del(key);
          form.hidden = true;
          root.querySelector('[data-sent]').hidden = false;
          const link = root.querySelector('[data-conv-link]');
          if (link && res.conversation && C.messages) link.href = `${C.messages}?c=${encodeURIComponent(res.conversation)}`;
        } catch (ex) {
          if (ex.code === 'login_required') { store.set(key, message); location.href = loginUrl(`${location.pathname}?contact=1`); return; }
          showErr(errMsg(ex.code));
        } finally {
          btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = t('contact_send');
        }
      });
    }
    // Offre
    const offerBtn = root.querySelector('[data-open-offer]');
    if (offerBtn) {
      const demande = Number(offerBtn.dataset.prix) || 0;
      const okey = `sra_offer_${id}`;
      const toLogin = r => { store.set(okey, JSON.stringify(r)); location.href = loginUrl(`${location.pathname}?offre=1`); };
      const sendOffer = async r => {
        if (!C.customer) { toLogin(r); return; }
        offerBtn.disabled = true;
        try {
          const nom = form && form.elements.nom ? form.elements.nom.value : '';
          const res = await api('offre', { json: { id, prix: r.prix, message: r.message, nom } });
          store.del(okey);
          if (form) form.hidden = true;
          const sent = root.querySelector('[data-sent]');
          if (sent) {
            sent.hidden = false;
            sent.querySelector('p').textContent = t('offer_sent');
            const link = sent.querySelector('[data-conv-link]');
            if (link && C.messages) link.href = `${C.messages}?c=${encodeURIComponent(res.conversation)}`;
          }
          toast(t('offer_sent'), 3500);
        } catch (ex) {
          if (ex.code === 'login_required') { toLogin(r); return; }
          store.del(okey);
          toast(errMsg(ex.code), 4500);
        } finally { offerBtn.disabled = false; }
      };
      offerBtn.addEventListener('click', async () => {
        const r = await offerDialog({ title: t('offer_title'), demande, withMessage: true });
        if (r) sendOffer(r);
      });
      const pending = store.get(okey);
      if (pending && C.customer) { try { sendOffer(JSON.parse(pending)); } catch { store.del(okey); } }
    }

    root.querySelector('[data-goto-contact]')?.addEventListener('click', e => {
      e.preventDefault();
      document.getElementById('contact').scrollIntoView({ behavior: 'smooth', block: 'start' });
      const m = root.querySelector('[data-contact] textarea');
      if (m) setTimeout(() => m.focus({ preventScroll: true }), 400);
    });

    // Signalement
    const dlg = root.querySelector('[data-report-dialog]');
    if (dlg) {
      const rform = dlg.querySelector('[data-report]');
      const rerr = rform.querySelector('[data-error]');
      const done = rform.querySelector('[data-done]');
      root.querySelector('[data-open-report]').addEventListener('click', () => {
        rform.reset(); rerr.hidden = true; done.hidden = true;
        rform.querySelector('[data-send-report]').hidden = false;
        dlg.showModal();
      });
      rform.querySelector('[data-close-report]').addEventListener('click', () => dlg.close());
      rform.addEventListener('submit', async e => {
        e.preventDefault();
        const motif = rform.elements.motif.value;
        if (!motif) { rerr.textContent = t('err_field'); rerr.hidden = false; return; }
        const btn = rform.querySelector('[data-send-report]');
        btn.disabled = true;
        try {
          await api('signaler', { json: { id, motif, details: rform.elements.details.value } });
          done.hidden = false; rerr.hidden = true; btn.hidden = true;
          setTimeout(() => dlg.open && dlg.close(), 2200);
        } catch (ex) {
          rerr.textContent = errMsg(ex.code); rerr.hidden = false;
        } finally { btn.disabled = false; }
      });
    }
  }

  /* ---------------------------------------------------------------- */
  /* Mes annonces                                                      */
  /* ---------------------------------------------------------------- */
  function initMine() {
    // Boutons des e-mails (garder en ligne, vendue, remettre en ligne) : fonctionnent sans être connecté
    const p = new URLSearchParams(location.search);
    const vieDone = root.querySelector('[data-vie-done]');
    const vieAct = p.get('vie');
    const vieReady = vieAct
      ? api('vie', { json: { act: vieAct, a: p.get('a'), t: p.get('t') } })
        .then(() => { vieDone.textContent = t(`vie_${vieAct}_done`); vieDone.hidden = false; })
        .catch(ex => { vieDone.textContent = errMsg(ex.code); vieDone.className = 'sra-note sra-note--warn'; vieDone.hidden = false; })
        .finally(() => history.replaceState(null, '', location.pathname))
      : Promise.resolve();
    const list = root.querySelector('[data-mine]');
    if (!list) return;
    const status = root.querySelector('[data-mine-status]');
    const empty = root.querySelector('[data-mine-empty]');

    // 16-10-2026 : une annonce vendue reste visible 7 jours avec un bandeau, puis disparaît.
    const SOLD_CONFIRM = {
      fr: 'Marquer cette annonce comme vendue ? Elle restera visible 7 jours avec un bandeau « Vendue », sans contact possible, puis disparaîtra.',
      nl: 'Dit zoekertje als verkocht markeren? Het blijft nog 7 dagen zichtbaar met een banner « Verkocht », zonder contactmogelijkheid, en verdwijnt dan.',
      en: 'Mark this listing as sold? It will stay visible for 7 days with a « Sold » banner, with no way to contact you, and will then disappear.',
      de: 'Diese Anzeige als verkauft markieren? Sie bleibt noch 7 Tage mit einem Banner « Verkauft » sichtbar, ohne Kontaktmöglichkeit, und verschwindet dann.',
      es: '¿Marcar este anuncio como vendido? Seguirá visible 7 días con una banda « Vendido », sin posibilidad de contacto, y después desaparecerá.',
      pt: 'Marcar este anúncio como vendido? Ficará visível durante 7 dias com uma faixa « Vendida », sem possibilidade de contacto, e depois desaparecerá.',
      it: 'Segnare questo annuncio come venduto? Resterà visibile per 7 giorni con una fascia « Venduto », senza possibilità di contatto, e poi sparirà.'
    };
    const etat = a => {
      if (a.bloquee) return ['blocked', 'st_blocked'];
      if (a.expiree) return ['hidden', 'st_expired'];
      if (a.status === 'ACTIVE' && a.statut === 'vendue') return ['sold', 'st_sold'];
      if (a.status === 'ACTIVE') return a.statut === 'reservee' ? ['reserved', 'st_reserved'] : ['online', 'st_online'];
      return a.statut === 'vendue' ? ['sold', 'st_sold'] : ['hidden', 'st_hidden'];
    };
    const actions = a => {
      const out = [];
      const edit = `${C.deposer}?modifier=${encodeURIComponent(a.id)}`;
      if (a.bloquee) return [['supprimer', 'act_delete']];
      // Vendue : encore visible 7 jours avec le bandeau ; on peut la remettre en vente (erreur) ou la retirer tout de suite.
      if (a.status === 'ACTIVE' && a.statut === 'vendue') return [['view', 'act_view', a.url], ['en_vente', 'act_republish'], ['retiree', 'act_hide']];
      if (a.status === 'ACTIVE') {
        out.push(['view', 'act_view', a.url], ['edit', 'act_edit', edit]);
        out.push(a.statut === 'reservee' ? ['en_vente', 'act_available'] : ['reservee', 'act_reserve']);
        out.push(['vendue', 'act_sold'], ['retiree', 'act_hide']);
        // Prolonger quand il reste moins de 3 semaines avant l'expiration
        if (a.expire && new Date(a.expire) - Date.now() < 21 * 86400000) out.push(['prolonger', 'act_extend']);
      } else {
        out.push(['edit', 'act_edit', edit], ['en_vente', 'act_republish'], ['supprimer', 'act_delete']);
      }
      return out;
    };

    function render(items) {
      list.innerHTML = '';
      empty.hidden = items.length > 0;
      for (const a of items) {
        const [cls, lab] = etat(a);
        const li = document.createElement('li');
        li.className = 'sra-mine__item';
        const date = a.date ? new Date(a.date).toLocaleDateString(loc, { day: 'numeric', month: 'short', year: 'numeric' }) : '';
        li.innerHTML = `
          <a class="sra-mine__img" href="${a.status === 'ACTIVE' ? esc(a.url) : '#'}" ${a.status === 'ACTIVE' ? '' : 'tabindex="-1" aria-hidden="true"'}>
            ${a.image ? `<img src="${esc(a.image)}" alt="" loading="lazy">` : ''}
          </a>
          <div class="sra-mine__info">
            <span class="sra-pill sra-pill--${cls}">${esc(t(lab))}</span>
            <h2 class="sra-mine__title">${esc(a.titre)} · ${esc(money(a.prix))}</h2>
            <p class="sra-mine__meta">${esc(a.commune || '')}${date ? ` · ${esc(t('published_on', { DATE: date }))}` : ''} · ${esc(t(a.vues === 1 ? 'views_one' : 'views_many', { N: num(a.vues || 0) }))}${a.contacts ? ` · ${esc(t('messages_count', { N: a.contacts }))}` : ''}${a.status === 'ACTIVE' && a.expire ? ` · ${esc(t('expires_on', { DATE: new Date(a.expire).toLocaleDateString(loc, { day: 'numeric', month: 'short' }) }))}` : ''}</p>
          </div>
          <div class="sra-mine__actions"></div>`;
        const box = li.querySelector('.sra-mine__actions');
        for (const [act, label, href] of actions(a)) {
          let el;
          if (href) { el = document.createElement('a'); el.href = href; }
          else { el = document.createElement('button'); el.type = 'button'; el.addEventListener('click', () => run(a, act, label, el)); }
          el.className = `sra-btn sra-btn--small ${act === 'edit' ? 'sra-btn--primary' : 'sra-btn--ghost'}`;
          el.textContent = t(label);
          box.appendChild(el);
        }
        if (a.status !== 'ACTIVE') li.querySelector('.sra-mine__img').addEventListener('click', e => e.preventDefault());
        list.appendChild(li);
      }
    }

    async function run(a, act, label, btn) {
      if (act === 'vendue' && !(await confirmBox(SOLD_CONFIRM[(document.documentElement.lang || 'fr').slice(0, 2)] || t('confirm_sold'), t(label)))) return;
      if (act === 'supprimer' && !(await confirmBox(t('confirm_delete'), t(label)))) return;
      btn.disabled = true; btn.setAttribute('aria-busy', 'true');
      try {
        await api('statut', { json: { id: a.id, action: act } });
        if (act === 'prolonger') toast(t('extend_done'));
        await load();
      } catch (ex) {
        toast(errMsg(ex.code));
        btn.disabled = false; btn.removeAttribute('aria-busy');
      }
    }

    async function load() {
      status.hidden = false; status.textContent = t('loading');
      try {
        const d = await api('mes-annonces');
        status.hidden = true;
        render(d.annonces || []);
      } catch (ex) {
        if (ex.code === 'login_required') { location.href = loginUrl(); return; }
        status.textContent = errMsg(ex.code);
      }
    }
    vieReady.then(load);
    // Pastille des messages non lus
    const badge = root.querySelector('[data-unread]');
    if (badge) api('conversations').then(d => { if (d.unread) { badge.textContent = d.unread; badge.hidden = false; } }).catch(() => {});
  }

  /* ---------------------------------------------------------------- */
  /* Messagerie                                                        */
  /* ---------------------------------------------------------------- */
  function initMessages() {
    const box = root.querySelector('[data-inbox]');
    if (!box) return;
    const listEl = root.querySelector('[data-convs]');
    const listStatus = root.querySelector('[data-list-status]');
    const listEmpty = root.querySelector('[data-list-empty]');
    const placeholder = root.querySelector('[data-thread-placeholder]');
    const inner = root.querySelector('[data-thread-inner]');
    const msgsEl = root.querySelector('[data-msgs]');
    const form = root.querySelector('[data-compose]');
    const ta = form.elements.message;
    const sendBtn = root.querySelector('[data-compose-send]');
    const err = root.querySelector('[data-compose-error]');
    let current = null;
    let thread = null;
    let convs = [];
    const makeOffer = root.querySelector('[data-make-offer]');
    const reserveBox = root.querySelector('[data-t-reserve]');
    let timer = null;

    const fmtTime = iso => {
      const d = new Date(iso);
      if (isNaN(d)) return '';
      const today = new Date(); const same = d.toDateString() === today.toDateString();
      return same ? d.toLocaleTimeString(loc, { hour: '2-digit', minute: '2-digit' })
        : d.toLocaleDateString(loc, { day: 'numeric', month: 'short' }) + ' ' + d.toLocaleTimeString(loc, { hour: '2-digit', minute: '2-digit' });
    };
    const initial = name => esc((String(name || '?').trim()[0] || '?').toUpperCase());

    const preview = cv => {
      if (cv.lastEvent) return t(`offer_ev_${cv.lastEvent.a}`, { P: money(cv.lastEvent.p) });
      if (cv.lastOffer) return t('offer_preview', { P: money(cv.lastOffer.prix) }) + (cv.last ? ` · ${cv.last}` : '');
      return cv.last;
    };

    function renderList() {
      listStatus.hidden = true;
      listEmpty.hidden = convs.length > 0;
      listEl.innerHTML = convs.map(cv => `
        <li><button type="button" class="sra-conv${cv.id === current ? ' is-active' : ''}${cv.unread ? ' is-unread' : ''}" data-id="${esc(cv.id)}">
          <span class="sra-seller__avatar" aria-hidden="true">${initial(cv.other)}</span>
          <span class="sra-conv__body">
            <span class="sra-conv__top"><b>${esc(cv.other || t(cv.role === 'b' ? 'msg_seller' : 'msg_buyer'))}</b><time>${esc(fmtTime(cv.lastAt))}</time></span>
            <span class="sra-conv__titre">${esc(cv.titre)} · ${esc(money(cv.prix))}</span>
            <span class="sra-conv__last">${cv.lastMine ? '↩ ' : ''}${esc(preview(cv))}</span>
          </span>
          ${cv.unread ? `<span class="sra-pill sra-pill--online">${esc(t('msg_new'))}</span>` : ''}
        </button></li>`).join('');
    }

    async function loadList() {
      try {
        const d = await api('conversations');
        convs = d.conversations || [];
        renderList();
      } catch (ex) {
        if (ex.code === 'login_required') { location.href = loginUrl(); return; }
        listStatus.hidden = false; listStatus.textContent = errMsg(ex.code);
      }
    }

    function renderThread(cv) {
      placeholder.hidden = true; inner.hidden = false;
      root.querySelector('[data-t-avatar]').innerHTML = initial(cv.other);
      root.querySelector('[data-t-other]').textContent = cv.other || t(cv.role === 'b' ? 'msg_seller' : 'msg_buyer');
      root.querySelector('[data-t-role]').textContent = t(cv.role === 'b' ? 'msg_role_b' : 'msg_role_s');
      const lk = root.querySelector('[data-t-listing]');
      lk.href = cv.url; lk.hidden = cv.statut === 'retiree' || cv.statut === 'vendue';
      root.querySelector('[data-t-titre]').textContent = cv.titre;
      root.querySelector('[data-t-prix]').textContent = money(cv.prix);
      const st = root.querySelector('[data-t-status]');
      const stKey = { vendue: 'msg_st_vendue', retiree: 'msg_st_retiree', reservee: 'msg_st_reservee' }[cv.statut];
      st.hidden = !stKey; st.textContent = stKey ? t(stKey) : '';
      const atBottom = msgsEl.scrollHeight - msgsEl.scrollTop - msgsEl.clientHeight < 40;
      thread = cv;
      const pill = { pending: 'sra-pill--reserved', accepted: 'sra-pill--online' };
      msgsEl.innerHTML = cv.messages.map(m => {
        const time = `<time class="sra-msg__time">${esc(fmtTime(m.at))}</time>`;
        if (m.event) {
          return `<li class="sra-msg sra-msg--event"><p class="sra-msg__text">${esc(t(`offer_ev_${m.event.a}`, { P: money(m.event.p) }))}</p>${time}</li>`;
        }
        if (m.offer) {
          const o = m.offer;
          let actions = '';
          if (o.status === 'pending') {
            const a = (act, cls, label) => `<button type="button" class="sra-btn sra-btn--small ${cls}" data-offer-act="${act}" data-offer="${esc(o.id)}" data-prix="${o.prix}">${esc(t(label))}</button>`;
            actions = m.mine ? a('withdraw', 'sra-btn--ghost', 'offer_withdraw')
              : a('accept', 'sra-btn--primary', 'offer_accept') + a('decline', 'sra-btn--ghost', 'offer_decline') + a('counter', 'sra-btn--ghost', 'offer_counter');
          }
          return `<li class="sra-msg sra-msg--offer${m.mine ? ' sra-msg--mine' : ''}">
            <div class="sra-offer"><span class="sra-offer__label">${esc(t('offer_label'))}</span><b class="sra-offer__price">${esc(money(o.prix))}</b><span class="sra-pill ${pill[o.status] || ''}">${esc(t(`offer_st_${o.status}`))}</span></div>
            ${m.text ? `<p class="sra-msg__text">${esc(m.text)}</p>` : ''}
            ${actions ? `<div class="sra-offer__actions">${actions}</div>` : ''}
            ${time}</li>`;
        }
        return `<li class="sra-msg${m.mine ? ' sra-msg--mine' : ''}"><p class="sra-msg__text">${esc(m.text)}</p>${time}</li>`;
      }).join('');
      const actif = cv.statut === 'en_vente' || cv.statut === 'reservee';
      if (makeOffer) makeOffer.hidden = !actif;
      if (reserveBox) reserveBox.hidden = !(cv.role === 's' && cv.statut === 'en_vente' && cv.messages.some(m => m.offer && m.offer.status === 'accepted'));
      if (atBottom || !msgsEl.dataset.ready) { msgsEl.scrollTop = msgsEl.scrollHeight; msgsEl.dataset.ready = '1'; }
    }

    async function open(id, push) {
      if (current !== id) { msgsEl.dataset.ready = ''; ta.value = ''; err.hidden = true; }
      current = id;
      box.dataset.view = 'thread';
      if (push) history.replaceState(null, '', `${location.pathname}?c=${encodeURIComponent(id)}`);
      try {
        const d = await api(`conversation?id=${encodeURIComponent(id)}`);
        renderThread(d.conversation);
        const cv = convs.find(x => x.id === id);
        if (cv && cv.unread) { cv.unread = false; }
        renderList();
      } catch (ex) {
        placeholder.hidden = false; inner.hidden = true; placeholder.textContent = errMsg(ex.code);
      }
    }

    listEl.addEventListener('click', e => {
      const b = e.target.closest('[data-id]');
      if (b) open(b.dataset.id, true);
    });
    root.querySelector('[data-back]').addEventListener('click', () => {
      box.dataset.view = 'list'; current = null;
      history.replaceState(null, '', location.pathname);
      renderList();
    });

    form.addEventListener('submit', async e => {
      e.preventDefault();
      const message = ta.value.trim();
      if (!current || message.length < 2) { ta.focus(); return; }
      sendBtn.disabled = true; err.hidden = true;
      try {
        await api('repondre', { json: { id: current, message } });
        ta.value = '';
        await open(current, false);
        msgsEl.scrollTop = msgsEl.scrollHeight;
        loadList();
      } catch (ex) {
        err.textContent = errMsg(ex.code); err.hidden = false;
      } finally { sendBtn.disabled = false; ta.focus(); }
    });
    // Offres dans la conversation
    const sendOffer = async r => {
      try {
        await api('offre', { json: { conv: current, prix: r.prix, message: r.message } });
        await open(current, false);
        msgsEl.scrollTop = msgsEl.scrollHeight;
        loadList();
      } catch (ex) { toast(errMsg(ex.code), 4500); }
    };
    makeOffer?.addEventListener('click', async () => {
      if (!current || !thread) return;
      const r = await offerDialog({ title: t('offer_title'), demande: thread.prix, withMessage: true });
      if (r) sendOffer(r);
    });
    msgsEl.addEventListener('click', async e => {
      const b = e.target.closest('[data-offer-act]');
      if (!b || !current) return;
      const act = b.dataset.offerAct;
      if (act === 'counter') {
        const r = await offerDialog({ title: t('offer_counter_title'), demande: thread ? thread.prix : 0, withMessage: true });
        if (r) sendOffer(r);
        return;
      }
      if (act === 'accept' && !(await confirmBox(t('offer_confirm_accept', { P: money(Number(b.dataset.prix)) }), t('offer_accept')))) return;
      b.disabled = true;
      try {
        await api('offre-reponse', { json: { conv: current, offre: b.dataset.offer, action: act } });
        await open(current, false);
        loadList();
      } catch (ex) { toast(errMsg(ex.code), 4500); b.disabled = false; }
    });
    reserveBox?.querySelector('[data-reserve]')?.addEventListener('click', async e => {
      const b = e.currentTarget;
      if (!thread) return;
      b.disabled = true;
      try {
        await api('statut', { json: { id: thread.annonceId, action: 'reservee' } });
        toast(t('offer_reserved_done'));
        await open(current, false);
      } catch (ex) { toast(errMsg(ex.code), 4500); }
      b.disabled = false;
    });

    ta.addEventListener('keydown', e => {
      if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) { e.preventDefault(); form.requestSubmit(); }
    });

    // Rafraîchissement toutes les 15 s quand la page est visible
    const tick = async () => {
      if (document.hidden) return;
      await loadList();
      if (current && !ta.value) open(current, false);
    };
    timer = setInterval(tick, 15000);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) tick(); });

    (async () => {
      await loadList();
      const c = new URLSearchParams(location.search).get('c');
      if (c) open(c, false);
      else if (window.matchMedia('(min-width: 900px)').matches && convs[0]) open(convs[0].id, false);
    })();
  }

  /* ---------------------------------------------------------------- */
  /* Favoris et alertes                                                */
  /* ---------------------------------------------------------------- */
  function initFavoris() {
    relativeDates(root);
    const grid = root.querySelector('[data-fav-grid]');
    const status = root.querySelector('[data-fav-status]');
    const empty = root.querySelector('[data-fav-empty]');
    const render = () => {
      let n = 0;
      grid.querySelectorAll('[data-annonce]').forEach(li => {
        const b = li.querySelector('[data-fav]');
        const on = !!b && Fav.has(b.dataset.fav);
        li.hidden = !on;
        if (on) n++;
      });
      status.hidden = true;
      grid.hidden = n === 0;
      empty.hidden = n > 0;
    };
    document.addEventListener('sra:favs', render);
    favReady.then(render);

    // Lien « arrêter cette alerte » d'un e-mail
    const p = new URLSearchParams(location.search);
    const stopDone = root.querySelector('[data-stop-done]');
    const stopped = p.get('stop')
      ? api('desabonner', { json: { a: p.get('stop'), c: p.get('c'), t: p.get('t') } })
        .then(() => { stopDone.hidden = false; history.replaceState(null, '', location.pathname); })
        .catch(ex => toast(errMsg(ex.code), 4500))
      : Promise.resolve();

    const list = root.querySelector('[data-alerts]');
    if (!list) return;
    const aStatus = root.querySelector('[data-alerts-status]');
    const aEmpty = root.querySelector('[data-alerts-empty]');
    const etats = { comme_neuf: 1, tres_bon: 1, bon: 1, use: 1, pour_pieces: 1 };
    const renderAlerts = items => {
      aStatus.hidden = true;
      aEmpty.hidden = items.length > 0;
      list.innerHTML = '';
      for (const a of items) {
        const li = document.createElement('li');
        li.className = 'sra-alert';
        const date = a.createdAt ? new Date(a.createdAt).toLocaleDateString(loc, { day: 'numeric', month: 'long', year: 'numeric' }) : '';
        const qs = new URLSearchParams();
        ['q', 'marque', 'prix', 'etat', 'lieu'].forEach(k => { if (a[k] && (k !== 'etat' || etats[a[k]])) qs.set(k, a[k]); });
        li.innerHTML = `<div><p class="sra-alert__label">${esc(a.label || t('alert_all'))}</p>
          <p class="sra-alert__meta">${date ? esc(t('alert_created_on', { DATE: date })) : ''}</p></div>
          <div class="sra-alert__actions">
            <a class="sra-btn sra-btn--ghost sra-btn--small" href="${esc((C.liste || '') + (qs.toString() ? `?${qs}` : ''))}">${esc(t('alert_see'))}</a>
            <button type="button" class="sra-btn sra-btn--ghost sra-btn--small">${esc(t('alert_delete'))}</button>
          </div>`;
        li.querySelector('button').addEventListener('click', async e => {
          const btn = e.currentTarget;
          btn.disabled = true;
          try {
            const d = await api('alerte', { json: { action: 'delete', id: a.id } });
            renderAlerts(d.alertes || []);
            toast(t('alert_deleted'));
          } catch (ex) { btn.disabled = false; toast(errMsg(ex.code)); }
        });
        list.appendChild(li);
      }
    };
    stopped.then(() => api('alertes'))
      .then(d => renderAlerts(d.alertes || []))
      .catch(ex => { aStatus.textContent = errMsg(ex.code); });
  }

  /* Profil vendeur : chiffres publics lus via /apps/annonces/vendeur */
  const vendeurCache = {};
  const vendeurInfo = cle => (vendeurCache[cle] = vendeurCache[cle] || api(`vendeur?v=${encodeURIComponent(cle)}`).then(d => d.vendeur));
  const moisAnnee = iso => { const d = new Date(iso); return isNaN(d) ? '' : d.toLocaleDateString(loc, { month: 'long', year: 'numeric' }); };
  const reactivite = r => {
    if (!r || r.delai_min == null) return '';
    return t(r.delai_min < 60 ? 'vendeur_reply_1h' : r.delai_min < 360 ? 'vendeur_reply_hours' : r.delai_min < 1440 ? 'vendeur_reply_day' : 'vendeur_reply_days');
  };

  // Page d'annonce : « Membre depuis … · Répond en général … » sous le pseudo.
  function sellerStats() {
    const link = root.querySelector('[data-vendeur]');
    const out = root.querySelector('[data-seller-stats]');
    if (!link || !out) return;
    vendeurInfo(link.dataset.vendeur).then(v => {
      const parts = [];
      if (v.membre_depuis) parts.push(t('vendeur_since', { DATE: moisAnnee(v.membre_depuis) }));
      const r = reactivite(v.reponse);
      if (r) parts.push(r);
      if (!parts.length) return;
      out.textContent = parts.join(' · ');
      out.hidden = false;
    }).catch(() => {});
  }

  function initVendeur() {
    relativeDates(root);
    const cle = String(new URLSearchParams(location.search).get('v') || '').toLowerCase();
    const status = root.querySelector('[data-v-status]');
    const notFound = root.querySelector('[data-v-notfound]');
    const grid = root.querySelector('[data-v-grid]');
    const empty = root.querySelector('[data-v-empty]');
    const valid = /^[0-9a-f]{16}$/.test(cle);
    let n = 0;
    grid.querySelectorAll('[data-annonce]').forEach(li => {
      const on = valid && li.dataset.v === cle;
      li.hidden = !on;
      if (on) n++;
    });
    grid.hidden = n === 0;
    if (!valid) { status.hidden = true; notFound.hidden = false; return; }
    vendeurInfo(cle).then(v => {
      status.hidden = true;
      empty.hidden = n > 0;
      const visible = grid.querySelector('[data-annonce]:not([hidden])');
      const pseudo = v.pseudo || (visible && visible.dataset.pseudo) || t('vendeur_title');
      root.querySelector('[data-v-name]').textContent = pseudo;
      root.querySelector('[data-v-avatar]').textContent = pseudo.slice(0, 1);
      document.title = `${pseudo} · ${document.title}`;
      if (v.membre_depuis) root.querySelector('[data-v-since]').textContent = t('vendeur_since', { DATE: moisAnnee(v.membre_depuis) });
      const enLigne = Math.max(n, v.en_ligne || 0);
      const set = (k, val, one, many) => {
        root.querySelector(`[data-v-stat="${k}"]`).textContent = num(val);
        const lab = root.querySelector(`[data-v-label="${k}"]`);
        if (lab) lab.textContent = t(new Intl.PluralRules(loc).select(val) === 'one' ? one : many);
      };
      set('en_ligne', enLigne, 'vendeur_online_one', 'vendeur_online_many');
      set('vendues', v.vendues || 0, 'vendeur_sold_one', 'vendeur_sold_many');
      if (v.reponse) {
        root.querySelector('[data-v-stat="taux"]').textContent = `${v.reponse.taux} %`;
        root.querySelector('[data-v-rate]').hidden = false;
        root.querySelector('[data-v-reply]').textContent = reactivite(v.reponse) || t('vendeur_reply_none');
      }
      root.querySelector('[data-v-stats]').hidden = false;
    }).catch(ex => {
      status.hidden = true;
      if (n > 0) return; // les annonces restent visibles même sans les chiffres
      if (ex.code === 'vendeur_unavailable') notFound.hidden = false;
      else { notFound.textContent = errMsg(ex.code); notFound.hidden = false; }
    });
  }

  const kind = root.dataset.sra;
  const favReady = (kind === 'favoris' || document.querySelector('[data-fav]')) ? Fav.load() : Promise.resolve();
  if (kind === 'liste') initListe();
  else if (kind === 'favoris') initFavoris();
  else if (kind === 'detail') { initDetail(); sellerStats(); }
  else if (kind === 'vendeur') initVendeur();
  else if (kind === 'mine') initMine();
  else if (kind === 'messages') initMessages();
})();
